<template>
  <div>
    <cube-input
      class="bank-input"
      v-bind="$attrs"
      v-on="$listeners"
      @input="input"
      @blur="blur"
      @focus="focus"
    >
    </cube-input>
    <div v-if="showBankName" class="bank">{{bankName}}</div>
    <span v-if="showWarn" class="icon-warn" @click="goCardList"><i aria-label="查看支持银行"></i></span>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    showBankName: {
      type: Boolean,
      default: false
    },
    bankName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showWarn: true
    }
  },
  methods: {
    goCardList() {
      this.$emit('goCardList')
    },
    blur() {
      this.showWarn = true
      this.$emit('blur')
    },
    focus() {
      this.showWarn = false
      this.$emit('focus')
    },
    input() {
      this.showWarn = false
      this.$emit('input')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "common-css/mixins.scss";
.bank-input {
  position: relative;
}
.bank {
  font-size: px2rem(24);
  position: absolute;
  margin-left: px2rem(20);
}
.icon-warn {
  position: absolute;
  right: 0;
  top: px2rem(28);
  right: px2rem(24);
  display: inline-block;
  padding: 2px;
  i {
    display: inline-block;
    width: 16px;
    height: 16px;
    @include bg-image('../../common/images/info');
    background-size: 16px 16px;
  }
}
</style>
